import { doPost, doGet, doPut, doDelete } from "../base";

const QUESTIONNAIRES_URL = "/user_auth/questionnaires";
const QUESTIONS_URL = (questionnaireId) => "/user_auth/questionnaires/" + questionnaireId + "/questions";
const ASSIGN_URL = (questionnaireId) => "/user_auth/questionnaires/" + questionnaireId + "/assign";

const SET_DAFAULTS = ({ limit, offset, sort }) => {
    let params = [];
    if (limit && limit !== null) {
        params.push("limit=" + limit);
    }
    if (offset && offset !== null) {
        params.push("offset=" + offset);
    }
    if (sort && sort !== null) {
        params.push("sort=" + sort);
    }
    
    return params;
}

export const getQuestionnaires = async ({ questionnaireId, limit, offset, sort, startDateRange, endDateRange, title }) => {

    var url = QUESTIONNAIRES_URL;
    if (questionnaireId) {
        url += "/" + questionnaireId;
    }
    let params = SET_DAFAULTS({limit, offset, sort});
    if (startDateRange && startDateRange !== null) {
        params.push("startDateRange=" + startDateRange);
    }
    if (endDateRange && endDateRange !== null) {
        params.push("endDateRange=" + endDateRange);
    }
    if (title && title !== null) {
        params.push("title=" + title);
    }
    for (let i=0; i < params.length; i++) {
        url += i > 0 ? "&" + params[i] : "?" + params[i];
    }
    
    return await doGet(url).catch((error) => {
        // TODO CHECK STATUS AND ERROR CODE.
        throw error;
    });
};

export const postQuestionnaire = async ({ title, description, startDate, endDate }) => {

    const payload = checkQuestionnairePayload(title, description, startDate, endDate);

    return await doPost(payload, QUESTIONNAIRES_URL).catch((error) => {
        // TODO CHECK STATUS AND ERROR CODE.
        throw error;
    })
}

export const putQuestionnaire = async ({ questionnaireId, title, description, startDate, endDate }) => {

    const payload = checkQuestionnairePayloadForUpdate(title, description, startDate, endDate);

    if (!questionnaireId) {
        throw new Error("questionnaireId cannot be null");
    }
    var url = QUESTIONNAIRES_URL + "/" + questionnaireId;
    
    
    return await doPut(payload, url).catch((error) => {
        // TODO CHECK STATUS AND ERROR CODE.  
        throw error;
    })
}

export const deleteQuestionnaire = async (questionnaireId) => {

    if (!questionnaireId) {
        throw new Error("questionnaireId cannot be null");
    }
    var url = QUESTIONNAIRES_URL + "/" + questionnaireId;
        
    return await doDelete(url).catch((error) => {
        // TODO CHECK STATUS AND ERROR CODE.  
        throw error;
    })
}

const checkQuestionnairePayload = (title, description, startDate, endDate) => {
    if (!title || title === null) {
        throw new Error("title cannot be null");
    }

    if (!startDate || startDate === null || startDate === 0) {
        throw new Error("startDate cannot be null or 0");
    }

    if (!endDate || endDate === null || endDate === 0) {
        throw new Error("endDate cannot be null or 0");
    }

    const payload = {
        title,
        description,
        startDate,
        endDate,
    };

    return payload;
}

const checkQuestionnairePayloadForUpdate = (title, description, startDate, endDate) => {
    if (!title || title === null) {
        throw new Error("title cannot be null");
    }
    let payload = {};

    if ((startDate === "" || startDate === null) && (endDate === "" || endDate === null)) {
        payload = {
            title,
            description
        };
    } else {
        payload = {
            title,
            description,
            startDate,
            endDate,
        };
    }

    return payload;
}

export const getQuestion = async (questionnaireId, {questionId, limit, offset, sort}) => {

    if (!questionnaireId || questionnaireId === null) {
        throw new Error("questionnaireId cannot be null.");
    }

    var url = QUESTIONS_URL(questionnaireId);
    if (questionId) {
        return url + "/" + questionId;
    }
    let params = SET_DAFAULTS({limit, offset, sort});
    
    for (let i=0; i < params.length; i++) {
        url += i > 0 ? "&" + params[i] : "?" + params[i];
    }
    
    return await doGet(url).catch((error) => {
        // TODO CHECK STATUS AND ERROR CODE.
        throw error;
    });
};

export const postQuestion = async (questionnaireId, { text, allowMultiple, description, orderNumber, required, type, answerOptions }) => {

    const payload = checkQuestionPayload(questionnaireId, text, allowMultiple, description, orderNumber, required, type, answerOptions);

    return await doPost(payload, QUESTIONS_URL(questionnaireId)).catch((error) => {
        // TODO CHECK STATUS AND ERROR CODE.
        throw error;
    })
};

export const putQuestion = async (questionnaireId, { text, allowMultiple, description, orderNumber, required, type, answerOptions }) => {

    const payload = checkQuestionPayload(questionnaireId, text, allowMultiple, description, orderNumber, required, type, answerOptions);

    return await doPut(payload, QUESTIONS_URL(questionnaireId)).catch((error) => {
        // TODO CHECK STATUS AND ERROR CODE.
        throw error;
    })
};

export const deleteQuestion = async (questionnaireId, questionId) => {

    if (!questionnaireId) {
        throw new Error("questionnaireId cannot be null");
    }

    if (!questionId) {
        throw new Error("question cannot be null");
    }

    var url = QUESTIONS_URL(questionnaireId) + "/" + questionId;

    return await doDelete(url).catch((error) => {
        // TODO CHECK STATUS AND ERROR CODE.
        throw error;
    })
}

const checkQuestionPayload = (questionnaireId, text, allowMultiple, description, orderNumber, required, type, answerOptions) => {
    if (!questionnaireId || questionnaireId === null) {
        throw new Error("questionnaireId cannot be null.");
    }

    if (!text || text === null) {
        throw new Error("text cannot be null");
    }

    if (!description || description === null) {
        throw new Error("description cannot be null");
    }

    if (allowMultiple === undefined || allowMultiple === null) {
        throw new Error("allowMultiple cannot be null");
    }

    if (!type || type == null) {
        type = "none";
    } else if (type !== "text" && type !== "image_text" && type !== "none"){
        throw new Error("type must be one of 'none', 'text', 'image_text'");
    }

    if (!orderNumber) {
        orderNumber = 0;
    }

    const payload = {
        text,
        description,
        allowMultiple,
        orderNumber,
        required,
        type,
        answerOptions,
    };

    return payload;
}

export const assignToPatient = async (questionnaireId, { assignIds, unassignIds }) => {

    const payload = {};

    if (assignIds && assignIds.length > 0) {
        payload.assignIds = assignIds;
    }

    if (unassignIds && unassignIds.length > 0) {
        payload.unassignIds = unassignIds;
    }

    return await doPost(payload, ASSIGN_URL(questionnaireId)).catch((error) => {
        // TODO CHECK STATUS AND ERROR CODE.
        throw error;
    })
};

export const getKarieUsers = async (questionnaireId) => {
    if (!questionnaireId || questionnaireId == null) {
        throw new Error("questionnaireId cannot be null.");
    }

    const url = ASSIGN_URL(questionnaireId) + "/patients";

    return await doGet(url).catch((error) => {
        // TODO CHECK STATUS AND ERROR CODE.
        throw error;
    });
};
